/**
 * 数字人页 · 与后台 models.model_id 对齐（可在「模型定价」改积分）
 * 全驱动：credits = 每秒单价，总价 = 单价 × 配音秒数（向上取整）
 */
export const DH_MODEL_REWRITE = 'video-copy-rewrite'
export const DH_MODEL_VOICE_CLONE = 'yinpin-voice-clone'
export const DH_MODEL_FULL_STANDARD = 'image-human-full'
export const DH_MODEL_FULL_FAST = 'image-human-full-fast'

/** 未拉到定价时的前端默认（全驱动为「每秒」积分） */
export const DH_MODEL_CREDITS_FALLBACK = {
  [DH_MODEL_REWRITE]: 5,
  [DH_MODEL_VOICE_CLONE]: 6,
  [DH_MODEL_FULL_STANDARD]: 6,
  [DH_MODEL_FULL_FAST]: 4
}

export function digitalHumanFullDriveModelId(mode) {
  return mode === 'fast' ? DH_MODEL_FULL_FAST : DH_MODEL_FULL_STANDARD
}
